module.exports = {"fileName":"/contracts/helpers/Stub.sol","name":"Stub","abi":[{"payable":false,"stateMutability":"nonpayable","type":"fallback"}],"source":"/**\n * Copyright 2017–2018, LaborX PTY\n * Licensed under the AGPL Version 3 license.\n */\n\npragma solidity ^0.4.11;\n\n// For testing purposes.\ncontract Stub {\n    function() public {}\n}\n","abiDocs":[{"payable":false,"stateMutability":"nonpayable","type":"fallback","inputs":[]}]}


//////////////////
// WEBPACK FOOTER
// ./docs/Stub.json
// module id = 1155
// module chunks = 0